// 保存用户信息
const SAVE_USER = 'SAVE_USER';
// 清除用户信息
const CLEAR_USER = 'CLEAR_USER';
const UserState = JSON.parse(localStorage.getItem('user')) || {};
export default function user (state = UserState, action) {
    switch (action.type) {
        case SAVE_USER:
            return state = action.user;
        case CLEAR_USER:
            return state = {};
        default:
            return state;
    }
}
